define('plugin/multiple-booking/view/MultipleBookingListItemView',['require','view/controller/booking/result/BookingResultItemView'],function (require) {

    var BookingResultItemView = require('view/controller/booking/result/BookingResultItemView');

    /**
     * Multiple booking list item view
     *
     * @class MultipleBookingListItemView
     */
    return BookingResultItemView.extend({

        mainTemplate: '#multiple_booking_list_item_view',
        popupTemplate: '#multiple_booking_popup_list_item_view',
        cartTemplate: '#multiple_booking_cart_list_item_view',

        getTemplate: function () {
            switch (this.getOption('mode')) {
                case 'popup':
                    return this.popupTemplate;
                case 'cart':
                    return this.cartTemplate;
                default:
                    return this.mainTemplate;
            }
        }

    });

});
